(function(){
 function init(){
 document.querySelectorAll('[data-khs]').forEach(function(R){
  if(R.__khs)return;R.__khs=1;
  var S=R.querySelectorAll('.khs-slide'),D=R.querySelectorAll('[data-khs-dot]'),n=S.length,i=0,t=null,ms=+R.getAttribute('data-auto')||0,paused=false;
  if(n<2)return;
  function go(k){i=(k+n)%n;S.forEach(function(s,j){s.classList.toggle('on',j===i);s.setAttribute('aria-hidden',j===i?'false':'true')});D.forEach(function(d,j){d.classList.toggle('on',j===i)});restart()}
  function restart(){clearTimeout(t);if(ms&&!paused)t=setTimeout(function(){go(i+1)},ms)}
  var p=R.querySelector('[data-khs-prev]'),nx=R.querySelector('[data-khs-next]');
  if(p)p.addEventListener('click',function(){go(i-1)});
  if(nx)nx.addEventListener('click',function(){go(i+1)});
  D.forEach(function(d){d.addEventListener('click',function(){go(+d.getAttribute('data-khs-dot'))})});
  R.addEventListener('mouseenter',function(e){if(window.matchMedia('(hover:hover)').matches){paused=true;clearTimeout(t)}});
  R.addEventListener('mouseleave',function(){paused=false;restart()});
  var sx=null,sy=0;
  R.addEventListener('touchstart',function(e){var a=e.touches[0];sx=a.clientX;sy=a.clientY},{passive:true});
  R.addEventListener('touchend',function(e){if(sx==null)return;var a=e.changedTouches[0],dx=a.clientX-sx,dy=a.clientY-sy;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))go(i+(dx<0?1:-1));sx=null},{passive:true});
  document.addEventListener('visibilitychange',function(){if(document.hidden)clearTimeout(t);else restart()});
  document.addEventListener('shopify:block:select',function(e){if(!R.contains(e.target))return;var idx=[].indexOf.call(S,e.target.closest('.khs-slide'));if(idx>-1){paused=true;go(idx)}});
  document.addEventListener('shopify:block:deselect',function(e){if(R.contains(e.target)){paused=false;restart()}});
  restart();
 });
 }
 if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
 document.addEventListener('shopify:section:load',init);
})();